import _ from 'lodash'
import Constants from '@/constants'
// import Util from '@/util'
// import moment from 'moment'
// import FormConstants from '@/base/formconstants'

const FormReferenceConstants = Object.freeze({
  Form: {
    COLUMNS: [], // [{
    //   name: 'first',
    //   label: 'First Name',
    //   type: 'input',
    //   class: 'is-4',
    // }],

    KEYS: [
      // { key: 'openingId', type: 'int', default: undefined },
      // { key: 'id', type: 'int', default: undefined },
      // { key: 'status', type: 'int', default: Constants.ApplicantStatus.NEW },
      // // info
      // { key: 'first', type: 'string', default: undefined },
      // { key: 'last', type: 'string', default: undefined },
      // { key: 'email', type: 'string', default: undefined },
      // { key: 'phone', type: 'string', default: undefined },
      // // address
      // { key: 'address', type: 'string', default: undefined },
      // { key: 'city', type: 'string', default: undefined },
      // { key: 'stateId', type: 'int', default: undefined },
      // { key: 'zip', type: 'string', default: undefined },
      // { key: 'countryId', type: 'int', default: undefined },
      // // objects (intermediate)
      // { key: 'references', type: 'array', default: [] },
      // { key: 'licenses', type: 'array', default: [] },
      // // refs
      // { key: 'opening', type: 'object', omit: true },
      // { key: 'uploads', type: 'array', omit: true },
      // // others
      // { key: 'createdAt', type: 'string', omit: true },
      // { key: 'createdBy', type: 'int', omit: true },
      // { key: 'modifiedAt', type: 'string', omit: true },
      // { key: 'modifiedBy', type: 'int', omit: true },
    ],

    KEYS_FILL: [
      // { key: 'openingId', type: 'int', default: undefined },
      // { key: 'id', type: 'int', default: undefined },
      // { key: 'status', type: 'int', default: Constants.ApplicantStatus.NEW },
      // // info
      // { key: 'first', type: 'string', default: 'Shark' },
      // { key: 'last', type: 'string', default: 'Applicant' },
      // { key: 'email', type: 'string', default: 'test@gmail.com' },
      // { key: 'phone', type: 'string', default: '(123)123-1234' },
      // // address
      // { key: 'address', type: 'string', default: 'test addr 1' },
      // { key: 'city', type: 'string', default: 'city1' },
      // { key: 'stateId', type: 'int', default: 1 },
      // { key: 'zip', type: 'string', default: '112233' },
      // { key: 'countryId', type: 'int', default: 1 },
    ],

    getValidators: (instance, params = {}) => {
      // let isRelocate = params.isRelocate
      // let isProvidedService = params.isProvidedService
      let validators = {
        // field: [{ required: true, trigger: 'blur', message: 'Required' }],
        // created_at: [{ required: true, trigger: 'blur', message: 'Required' }],
        // first: [{ required: true, trigger: 'blur', message: 'Required' }],
        // last: [{ required: true, trigger: 'blur', message: 'Required' }],
        // phone: [
        //   { required: true, trigger: 'blur', message: 'Required' },
        //   { required: true, trigger: 'blur', validator: Util.validators.validatorRegex.bind(instance), regex: new RegExp('^(\\([0-9]{3}\\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$'), message: 'Invalid format, e.g.: (123)123-1234' },
        // ],
        // email: [
        //   { required: true, trigger: 'blur', message: 'Required' },
        //   { required: true, trigger: 'blur', validator: Util.validators.validateEmail.bind(instance) }
        // ],
        // // mname: [{ required: true, trigger: 'blur', message: 'Required' }],
        // // lname: [{ required: true, trigger: 'blur', message: 'Required' }],
        // address: [{ required: true, trigger: 'blur', message: 'Required' }],
        // // address2: [{ required: true, trigger: 'blur', message: 'Required' }],
        // city: [{ required: true, trigger: 'blur', message: 'Required' }],
        // stateId: [{ required: true, trigger: 'change', message: 'Required' }],
        // zip: [{ required: true, trigger: 'blur', message: 'Required' }],
        // countryId: [{ required: true, trigger: 'change', message: 'Required' }],
        // isRelocate: [{ required: true, trigger: 'change', message: 'Required' }],
        // relocateTo: [{ required: isRelocate, trigger: 'blur', message: 'Required' }],
        // isProvidedService: [{ required: true, trigger: 'change', message: 'Required' }],
        // providedServiceDateFrom: [{ required: isProvidedService, trigger: 'blur', message: 'Required' }],
        // providedServiceDateTo: [{ required: isProvidedService, trigger: 'blur', message: 'Required' }],
        // images: [{ required: true, trigger: 'change', validator: Util.validators.validateFileRequired.bind(instance) }],
      }
      return validators
    },

    ENABLERS: [
      {
        key: 'relocateTo',
        criteria: [
          { param: 'isRelocate', value: Constants.OptionsYesNo.YES }
        ]
      }, {
        key: 'providedServiceDateFrom',
        criteria: [
          { param: 'isProvidedService', value: Constants.OptionsYesNo.YES }
        ]
      }, {
        key: 'providedServiceDateTo',
        criteria: [
          { param: 'isProvidedService', value: Constants.OptionsYesNo.YES }
        ]
      },
    ],

    updateEnablers: (instance, columns, form = {}) => {
      let enablers = FormReferenceConstants.Form.ENABLERS
      for (let e in enablers) {
        let enabler = enablers[e]
        let key = enabler.key
        let criterias = enabler.criteria || []
        let disabled = (!criterias || criterias.length <= 0)
        for (let c in criterias) {
          let criteria = criterias[c]
          let param = criteria.param
          let value = criteria.value
          if (!form.hasOwnProperty(param)) {
            disabled = true
            continue
          }
          if (form[param] !== value) {
            disabled = true
            continue
          }
        }
        let found = _.find(columns, (col) => col.name === key)
        if (found) {
          instance.$set(found, 'disabled', disabled)
        }
      }
    },
  },
})

export default FormReferenceConstants
